import React, { useEffect, useState } from "react";
import "../../css/account.scss";
import Header from "../common/Header";
import Footer from "../common/Footer";
import { useTranslation } from "react-i18next";
import { login } from "../../apis/LoginAPI";
import { modify_user } from "../../apis/ModifyUser";
import Cookies from "js-cookie";
import LocalStorageUtil from "../../utils/localStorageUtil";
import { sendMessage } from "../../apis/SendMessageAPI";
import { BASE_URL } from "../../constans/ApiEndpointConstants";

const Account = () => {
  const { t } = useTranslation();

  const toTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    toTop();
    const userid = localStorage.getItem("userid");
    const ad = LocalStorageUtil.getAd?.() ?? "PurityBase";
    sendMessage(`${BASE_URL} [Account Page]:ad=${ad}:userid=${userid}`);
  }, []);

  const [loginEmail, setLoginEmail] = useState("");
  const [loginPassword, setLoginPassword] = useState("");
  const [loginLoading, setLoginLoading] = useState(false);
  const [loginError, setLoginError] = useState("");

  const [regEmail, setRegEmail] = useState("");
  const [regPassword, setRegPassword] = useState("");
  const [regLoading, setRegLoading] = useState(false);
  const [regError, setRegError] = useState("");
  const [regSuccess, setRegSuccess] = useState(false);

  const [loginSuccess, setLoginSuccess] = useState(false);
  const [loggedInEmail, setLoggedInEmail] = useState("");

  useEffect(() => {
    const saved =
      Cookies.get("username") || localStorage.getItem("accountEmail");
    const token = Cookies.get("token");
    if (saved && token) {
      setLoggedInEmail(saved);
      setLoginSuccess(true);
    }
  }, []);

  const isLoggedIn = loginSuccess && loggedInEmail;

  const onLoginSubmit = (e) => {
    e && e.preventDefault && e.preventDefault();
    setLoginError("");
    const v = loginEmail.trim();
    if (!v) {
      setLoginError(t("account.errors.emailRequired"));
      return;
    }
    if (!loginPassword) {
      setLoginError(t("account.errors.passwordRequired"));
      return;
    }
    setLoginLoading(true);
    login(v, loginPassword, null)
      .then((res) => {
        setLoginLoading(false);
        const ok =
          res &&
          res.status === 200 &&
          (res.data?.code === 1 || res.data?.success || res.data === true);
        if (ok) {
          const dataBlock = res?.data?.data || {};
          const tokenVal = dataBlock?.token;
          const userBlock = dataBlock?.user || res?.data?.user || {};
          const userIdVal = userBlock?.id;
          const roleTypeVal = userBlock?.roleType || userBlock?.role || "";
          const apiUsername =
            res?.data?.data?.user?.username ||
            res?.data?.user?.username ||
            res?.data?.username ||
            v;
          try {
            if (tokenVal) Cookies.set("token", String(tokenVal), { path: "/" });
            if (roleTypeVal)
              Cookies.set("roleType", String(roleTypeVal), { path: "/" });
            if (userIdVal != null)
              Cookies.set("userId", String(userIdVal), { path: "/" });
            if (apiUsername)
              Cookies.set("username", String(apiUsername), { path: "/" });
          } catch {
            /* ignore */
          }
          setLoggedInEmail(String(apiUsername));
          setLoginSuccess(true);
          setLoginError("");
          try {
            localStorage.setItem("accountEmail", String(apiUsername));
          } catch {}
        } else {
          const msg =
            res?.data?.message ||
            res?.data?.msg ||
            t("account.errors.unknownEmail");
          setLoginError(String(msg));
        }
      })
      .catch((err) => {
        setLoginLoading(false);
        const msg =
          err?.response?.data?.message ||
          err?.message ||
          t("account.errors.loginFailed");
        setLoginError(String(msg));
      });
  };

  const onRegisterSubmit = (e) => {
    e && e.preventDefault && e.preventDefault();
    setRegError("");
    const emailVal = regEmail.trim();
    const passwordVal = regPassword.trim();
    if (!emailVal) {
      setRegError(t("account.errors.emailRequired"));
      return;
    }
    if (!passwordVal) {
      setRegError(t("account.errors.passwordRequired"));
      return;
    }
    setRegLoading(true);
    modify_user(
      null,
      emailVal,
      passwordVal,
      null,
      null,
      null,
      "user",
      null,
      null
    )
      .then((res) => {
        setRegLoading(false);
        const ok =
          res &&
          res.status === 200 &&
          (res.data?.code === 1 || res.data?.success || res.data === true);
        if (ok) {
          setRegSuccess(true);
          setLoginLoading(true);
          return login(emailVal, passwordVal, null)
            .then((r2) => {
              setLoginLoading(false);
              const ok2 =
                r2 &&
                r2.status === 200 &&
                (r2.data?.code === 1 || r2.data?.success || r2.data === true);
              if (ok2) {
                const dataBlock2 = r2?.data?.data || {};
                const tokenVal2 = dataBlock2?.token;
                const userBlock2 = dataBlock2?.user || r2?.data?.user || {};
                const userIdVal2 = userBlock2?.id;
                const roleTypeVal2 =
                  userBlock2?.roleType || userBlock2?.role || "";
                const apiUsername2 =
                  r2?.data?.data?.user?.username ||
                  r2?.data?.user?.username ||
                  r2?.data?.username ||
                  emailVal;
                try {
                  if (tokenVal2)
                    Cookies.set("token", String(tokenVal2), { path: "/" });
                  if (roleTypeVal2)
                    Cookies.set("roleType", String(roleTypeVal2), {
                      path: "/",
                    });
                  if (userIdVal2 != null)
                    Cookies.set("userId", String(userIdVal2), { path: "/" });
                  if (apiUsername2)
                    Cookies.set("username", String(apiUsername2), {
                      path: "/",
                    });
                } catch {}
                setLoggedInEmail(String(apiUsername2));
                setLoginSuccess(true);
                setRegError("");
                try {
                  localStorage.setItem("accountEmail", String(apiUsername2));
                } catch {}
              } else {
                const msg2 =
                  r2?.data?.message ||
                  r2?.data?.msg ||
                  t("account.errors.loginFailed");
                setRegError(String(msg2));
              }
            })
            .catch((e2) => {
              setLoginLoading(false);
              const msg2 =
                e2?.response?.data?.message ||
                e2?.message ||
                t("account.errors.loginFailed");
              setRegError(String(msg2));
            });
        } else {
          const msg =
            res?.data?.message ||
            res?.data?.msg ||
            t("account.errors.registerFailed");
          setRegError(String(msg));
        }
      })
      .catch((err) => {
        setRegLoading(false);
        const msg =
          err?.response?.data?.message ||
          err?.message ||
          t("account.errors.registerFailed");
        setRegError(String(msg));
      });
  };

  const onSignOut = () => {
    Cookies.remove("token", { path: "/" });
    Cookies.remove("roleType", { path: "/" });
    Cookies.remove("userId", { path: "/" });
    Cookies.remove("username", { path: "/" });
    localStorage.removeItem("accountEmail");
    setLoginSuccess(false);
    setLoginEmail("");
    setLoginPassword("");
    setLoggedInEmail("");
    setRegEmail("");
    setRegPassword("");
    setRegSuccess(false);
    setLoginError("");
    setRegError("");
  };

  return (
    <div className="account-page">
      <Header />
      <main className="account__container">
        <h1 className="account__title">{t("account.title")}</h1>

        {isLoggedIn ? (
          <div className="account-card account-card--session">
            <div className="account-form account-form--session">
              <p className="form__logged-in">
                {t("account.login.loggedInAs", { email: loggedInEmail })}
              </p>
              <button
                className="form__btn form__btn--outline"
                type="button"
                onClick={onSignOut}
              >
                {t("account.login.signOutUpper")}
              </button>
            </div>
          </div>
        ) : (
          <div className="account__grid">
            <section className="account-card account-card--form">
              <h2 className="account-card__title">
                {t("account.login.title")}
              </h2>
              <form
                className="account-form"
                onSubmit={onLoginSubmit}
                aria-busy={loginLoading || undefined}
              >
                {loginError && (
                  <div className="form__error" role="alert">
                    {loginError}
                  </div>
                )}
                <div className="form__field">
                  <label className="form__label" htmlFor="login-email">
                    {t("account.login.email")} <span className="req">*</span>
                  </label>
                  <input
                    className="form__input"
                    id="login-email"
                    type="text"
                    autoComplete="username"
                    value={loginEmail}
                    onChange={(e) => setLoginEmail(e.target.value)}
                  />
                </div>
                <div className="form__field">
                  <label className="form__label" htmlFor="login-password">
                    {t("account.login.password")} <span className="req">*</span>
                  </label>
                  <input
                    className="form__input"
                    id="login-password"
                    type="password"
                    autoComplete="current-password"
                    value={loginPassword}
                    onChange={(e) => setLoginPassword(e.target.value)}
                  />
                </div>
                <div className="form__actions">
                  <button
                    className="form__btn form__btn--block"
                    type="submit"
                    disabled={loginLoading}
                  >
                    {loginLoading
                      ? t("account.common.loading")
                      : t("account.login.btn")}
                  </button>
                </div>
              </form>
            </section>

            <section className="account-card account-card--form">
              <h2 className="account-card__title">
                {t("account.register.title")}
              </h2>
              {regSuccess && !loginSuccess ? (
                <div className="form__success" role="status">
                  {t("account.register.success")}
                </div>
              ) : (
                <form
                  className="account-form"
                  onSubmit={onRegisterSubmit}
                  aria-busy={regLoading || undefined}
                >
                  {regError && (
                    <div className="form__error" role="alert">
                      {regError}
                    </div>
                  )}
                  <div className="form__field">
                    <label className="form__label" htmlFor="reg-email">
                      {t("account.register.email")}{" "}
                      <span className="req">*</span>
                    </label>
                    <input
                      className="form__input"
                      id="reg-email"
                      type="email"
                      autoComplete="email"
                      value={regEmail}
                      onChange={(e) => setRegEmail(e.target.value)}
                    />
                  </div>
                  <div className="form__field">
                    <label className="form__label" htmlFor="reg-password">
                      {t("account.register.password")}{" "}
                      <span className="req">*</span>
                    </label>
                    <input
                      className="form__input"
                      id="reg-password"
                      type="password"
                      autoComplete="new-password"
                      value={regPassword}
                      onChange={(e) => setRegPassword(e.target.value)}
                    />
                  </div>

                  <div className="form__actions">
                    <button
                      className="form__btn form__btn--block"
                      type="submit"
                      disabled={regLoading}
                    >
                      {regLoading
                        ? t("account.common.loading")
                        : t("account.register.btn")}
                    </button>
                  </div>
                </form>
              )}
            </section>
          </div>
        )}
      </main>
      <Footer />
    </div>
  );
};

export default Account;
